import React, { useState } from 'react'
import { Table } from 'react-bootstrap'
import ToggleBar from '../../commoncomponents/toggleBar'
import { utcToReportDate } from '../../../utils/dateConvert'
import { downloadCSVFile } from '../../../api/apiClient'
import Location from '../../commoncomponents/location';
import ShowIButtonName from '../../commoncomponents/showIButtonName';
import { formatTemperatureReading, temperatureReadingClass } from '../../../utils/temperature';


function GeneralException(props) {
    let tempBEnabled = props.tempBEnabled;
    let driverIDEnabled = props.driverIDEnabled;
    let assetId = props.assetId;
  
    const [tempABoolean] = useState(props.reportDetail[0] ? props.reportDetail[0].sensorAValue !== null || typeof props.reportDetail[0].sensorAValue !== "undefined" ? true : false : "");
    const [tempBBoolean] = useState(tempBEnabled && (props.reportDetail[0] ? props.reportDetail[0].sensorBValue !== null || typeof props.reportDetail[0].sensorBValue !== "undefined" ? true : false : ""));

    let assetName = props.assetCustomerName;
    let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
    const data = (
        <Table responsive striped>
            <thead>
                <tr className="nowwrapTH">
                    <th>ID</th>
                    <th>Created</th>
                    <th>Location</th>
                    <th>Type</th>
                    <th>Speed</th>
                    <th>Ignition</th>
                    <th>Fridge</th>

                    {tempABoolean && <th>Temp A</th>}
                    {tempBBoolean && <th>Temp B </th>}
                    {driverIDEnabled && (<th>Driver ID</th>)}
                </tr>
            </thead>
            <tbody>
                {props.reportDetail.map((message, index) => {
                    const item = message.rawMessage
                    return (
                        <tr key={index}>
                            <td>{item.id}</td>
                            <td>{utcToReportDate(item.gPRMC.created)}</td>
                            <td>
                                <Location
                                    address={item.location}
                                    lat={item.gPRMC.latitude}
                                    lng={item.gPRMC.longitude}
                                />
                            </td>
                            <td>{item.messageName}</td>
                            <td>{Math.round((item.gPRMC.speed + Number.EPSILON) * 100) / 100}</td>
                            <td>{item.iO3 == 0 ? "Engine Off" : "Engine On"}</td>
                            <td>{item.iO1 != 0 ? "On" : "Off"}</td>

                            {tempABoolean && <td className={temperatureReadingClass(item.sensorAValue)}>{formatTemperatureReading(item.sensorAValue)}</td>}
                            {tempBBoolean && <td className={temperatureReadingClass(item.sensorBValue)}>{formatTemperatureReading(item.sensorBValue)}</td>}
                            {driverIDEnabled && <td>
                                {item.ibutton && 
                                <ShowIButtonName
                                    ibuttonId={message.ibuttonId}
                                    serialno={message.serialno}
                                    iButtonName={message.iButtonName}
                                />
                                }
                                </td>}
                        </tr>
                    )

                })}

            </tbody>
        </Table>
    )

    const handleDownloadExcel = () => {
        const csvData = props.reportDetail.map(message => {
            const item = message.rawMessage;
            return {
                ...item,
                speed: Math.round((item.gPRMC.speed + Number.EPSILON) * 100) / 100,
            }
        });

        downloadCSVFile(csvData, "GeneralException", assetName, timeZone, assetId);
    }

    return (
        <ToggleBar caption="General Exceptions" download={handleDownloadExcel} icon="fa-warning" color="#A94442" content={data} />
    )
}

export default GeneralException
